import React, { useEffect, useState } from 'react';
import { Table, Button, message, Select, DatePicker, Spin } from 'antd';
import { Timesheetapi } from '../../../middleware/interceptor';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";

dayjs.extend(utc);
dayjs.extend(timezone);

const today = dayjs().utc().toDate();

const { RangePicker } = DatePicker;

export const Approvals = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [loading, setloading] = useState(false);
    const [sDate, setSdate] = useState();
    const [eDate, setEdate] = useState();
    const [approvals, setApprovals] = useState([]);
    const [Temp, setTemp] = useState([]);

    const [selectedTimePeriod, setSelectedTimePeriod] = useState('week');

    const [filterdata, setfilterdata] = useState([]);

    const [clients, setclients] = useState([{ label: 'All', value: 1 }]);
    const [Projects, setprojects] = useState([{ label: 'All', value: 1 }]);
    const [employee, setemployee] = useState([{ label: 'All', value: 1 }]);

    const [selectedclients, setselectedclients] = useState(1);
    const [selectedProjects, setselectedprojects] = useState(1);
    const [selectedemployee, setselectedemployee] = useState(1);

    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedWeekDates, setSelectedWeekDates] = useState([]);

    // From the API: false = no one reports to me on the Org Chart (nothing to approve)
    const [canApprove, setCanApprove] = useState(true);

    const options = [
        { label: 'Day Approve', value: 'day' },
        { label: 'Weekly Approve', value: 'week' },
        { label: 'Monthly Approve', value: 'month' }
    ];

    const columns = [
        {
            title: 'Date',
            dataIndex: 'commentDate',
            key: 'commentDate',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Clients',
            dataIndex: 'clientName',
            key: 'clientName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Projects',
            dataIndex: 'projectName',
            key: 'projectName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Employees',
            dataIndex: 'employeeName',
            key: 'employeeName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Tasks',
            dataIndex: 'taskName',
            key: 'taskName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Comments',
            dataIndex: 'commentContent',
            key: 'commentContent',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Hrs',
            dataIndex: 'commentHours',
            key: 'commentHours',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>
        },
        {
            title: 'Reporting to',
            dataIndex: 'reportsTo',
            key: 'reportsTo',
            align: 'center',
            render: (text, row) => (
                <div style={{ textAlign: 'left' }}>
                    {text}
                    <div style={{ fontSize: 11, color: '#5B6474' }}>
                        {row.level === 1 ? 'Your direct report'
                            : row.level > 1 ? `In your team (level ${row.level})`
                            : text === 'Not assigned on Org Chart' ? 'Comes to the top of the Org Chart'
                            : 'Another team (you are the top of the Org Chart)'}
                    </div>
                </div>
            )
        }
    ];

    const formatDateToDDMMYYYY = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`; // yyyy-mm-dd
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys);
            setSelectedRowsData(newSelectedRows);
        },
    };

    const clearSelection = () => {
        setSelectedRowKeys([]);
        setSelectedRowsData([]);
    };

    // action: 'Approve' | 'Deny' → api/OrgApprovals/Approve | Deny (only entries of people in my team are changed)
    const act = async (action) => {
        if (selectedRowKeys.length === 0) {
            message.warning(`Please select at least one entry to ${action === 'Approve' ? 'approve' : 'deny'}.`);
            return;
        }
        setloading(true);
        try {
            const res = await Timesheetapi.post(`api/OrgApprovals/${action}`, {
                empid: localStorage.getItem('employee_id'),
                Ids: selectedRowsData.map(item => item.commentId),
            });
            if (res.data?.status === 1) {
                if (action === 'Approve') message.success(res.data.message);
                else message.warning(res.data.message);
                clearSelection();
                getapprovalsdata();
            } else {
                message.error(res.data?.message || `Could not ${action === 'Approve' ? 'approve' : 'deny'}.`);
                setloading(false);
            }
        } catch (err) {
            console.error(`${action} failed:`, err);
            message.error(`Could not ${action === 'Approve' ? 'approve' : 'deny'}. Try again.`);
            setloading(false);
        }
    };
    const approve = () => act('Approve');
    const deny = () => act('Deny');

    useEffect(() => {
        if (selectedTimePeriod === 'month' || selectedTimePeriod === 'year' || selectedTimePeriod === 'day') {
            const currentStartDate = dayjs().utc().startOf(selectedTimePeriod);
            const currentEndDate = dayjs().utc().endOf(selectedTimePeriod);
            setSdate(currentStartDate.format("YYYY-MM-DD"));
            setEdate(currentEndDate.format("YYYY-MM-DD"));
        }
    }, [selectedTimePeriod]);

    useEffect(() => {
        if (sDate && eDate) {
            getapprovalsdata();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sDate, eDate]);

    useEffect(() => {
        if (selectedTimePeriod === 'week') {
            handleWeekSelection([new Date(today)]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTimePeriod]);

    const getapprovalsdata = async () => {
        setloading(true);
        clearSelection();

        try {
            const response = await Timesheetapi.get(`api/OrgApprovals/Pending`, {
                params: {
                    empid: localStorage.getItem('employee_id'),
                    sdate: sDate,
                    edate: eDate,
                }
            });

            if (response.data?.status !== 1) {
                message.error(response.data?.message || 'Could not load approvals.');
                setloading(false);
                return;
            }
            setCanApprove(response.data.canApprove !== false);

            const results = response.data.Results || [];
            const flattenedData = flattenApprovalsData(results);

            const filteredData = results.map(client => {
                const filteredProjects = client.Project_List.map(project => ({
                    ...project,
                    workitems: project.workitems.filter(item => item.comments && item.comments.length > 0)
                })).filter(project => project.workitems.length > 0);
                return { ...client, Project_List: filteredProjects };
            }).filter(client => client.Project_List.length > 0);

            const clientOptions = results.map(client => ({
                label: client.Client_name,
                value: client.Client_id
            }));

            setfilterdata(filteredData);
            setApprovals(flattenedData);
            setTemp(flattenedData);
            setclients([{ label: 'All', value: 1 }, ...clientOptions]);
            setprojects([{ label: 'All', value: 1 }]);
            setemployee([{ label: 'All', value: 1 }]);
            setselectedprojects(1);
            setselectedemployee(1);
        } catch (err) {
            console.error('Approvals load failed:', err);
            message.error('Could not load approvals.');
        } finally {
            setloading(false);
        }
    };

    const handleChange = (value) => {
        setselectedclients(value);
    };

    const handleChangeproject = (value) => {
        const employeeMap = new Map();
        setselectedprojects(value);
        setselectedemployee(1);
        filterdata.forEach(client => {
            client.Project_List.forEach(project => {
                if (project.Project_id === value) {
                    project.workitems
                        .filter(item => item.comments && item.comments.length > 0)
                        .forEach(item => {
                            if (!employeeMap.has(item.employee_id)) {
                                employeeMap.set(item.employee_id, { label: item.employee_name, value: item.employee_id });
                            }
                        });
                }
            });
        });
        setemployee([{ label: 'All', value: 1 }, ...Array.from(employeeMap.values())]);
    };

    const flattenApprovalsData = (data) => {
        const result = [];
        data.forEach(client => {
            client.Project_List.forEach(project => {
                project.workitems.forEach(workitem => {
                    if (workitem.comments && workitem.comments.length > 0) {
                        workitem.comments.forEach(comment => {
                            result.push({
                                key: comment.CommentId,
                                clientName: client.Client_name,
                                projectName: project.Project_name,
                                employeeName: workitem.employee_name,
                                taskName: workitem.ItemName,
                                Client_id: client.Client_id,
                                Project_id: project.Project_id,
                                Employee_id: workitem.employee_id,
                                commentId: comment.CommentId,
                                commentContent: comment.content,
                                commentDate: comment.comments_Date,
                                commentHours: comment.Comment_hrs,
                                reportsTo: comment.Reports_To || '',
                                level: comment.Level || 0
                            });
                        });
                    }
                });
            });
        });
        return result;
    };

    const handleDateChange = (date) => {
        if (date && date.length === 2) {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (selectedTimePeriod === 'month' || selectedTimePeriod === 'year' || selectedTimePeriod === 'day') {
                setSdate(dayjs(date[0]).tz(userTimeZone).startOf(selectedTimePeriod).format("YYYY-MM-DD"));
                setEdate(dayjs(date[1]).tz(userTimeZone).endOf(selectedTimePeriod).format("YYYY-MM-DD"));
            }
        }
    };

    const handleTimePeriodChange = (value) => {
        setSelectedTimePeriod(value);
        setSelectedDates([dayjs().startOf(value), dayjs().endOf(value)]);
    };

    const handleWeekSelection = (selectedDates_, instance) => {
        if (instance) { instance.close(); }
        if (selectedDates_.length > 0) {
            const selectedTempDate = new Date(selectedDates_[0]);
            selectedTempDate.setHours(0, 0, 0, 0);

            const startOfWeek = new Date(selectedTempDate);
            const dayOfWeek = startOfWeek.getDay();
            const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
            startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
            startOfWeek.setHours(0, 0, 0, 0);

            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            endOfWeek.setHours(0, 0, 0, 0);

            setSelectedWeekDates([startOfWeek, endOfWeek]);
            setSdate(formatDateToDDMMYYYY(new Date(startOfWeek)));
            setEdate(formatDateToDDMMYYYY(new Date(endOfWeek)));
        }
    };

    // Client / Project / Employee filters
    useEffect(() => {
        const filtered = Temp.filter(row => {
            const clientMatch = selectedclients == 1 || row.Client_id === selectedclients;
            const projectMatch = selectedProjects == 1 || row.Project_id === selectedProjects;
            const employeeMatch = selectedemployee == 1 || row.Employee_id === selectedemployee;
            return clientMatch && projectMatch && employeeMatch;
        });
        setApprovals(filtered);
    }, [Temp, selectedclients, selectedProjects, selectedemployee]);

    useEffect(() => {
        const filter = filterdata.filter(client => client.Client_id === selectedclients);
        if (filter.length > 0) {
            const project = filter[0].Project_List.map(project => ({
                label: project.Project_name,
                value: project.Project_id
            }));
            setprojects([{ label: 'All', value: 1 }, ...project]);
        } else {
            setprojects([{ label: 'All', value: 1 }]);
        }
        setselectedprojects(1);
        setemployee([{ label: 'All', value: 1 }]);
        setselectedemployee(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Temp, selectedclients]);

    const table = (
        <div className='mt-3 approval-table pt-[70px]'>
            <Table
                rowSelection={rowSelection}
                dataSource={approvals}
                columns={columns}
                pagination={loading ? false : { pageSize: 10, showSizeChanger: false }}
                locale={{ emptyText: canApprove ? 'Nothing waiting for approval in this period' : 'No one reports to you on the Org Chart, so there is nothing for you to approve.' }}
            />
            <div className='flex items-center justify-end mt-2 gap-2 px-[10px] pb-[10px]'>
                {selectedRowKeys.length > 0 && (
                    <span className='text-[13px] text-gray-500 mr-2'>{selectedRowKeys.length} selected</span>
                )}
                <Button type="primary" onClick={approve} disabled={loading}>
                    Approve
                </Button>
                <Button danger onClick={deny} disabled={loading}>
                    Deny
                </Button>
            </div>
        </div>
    );

    return (
        <div>
            <h2 className='page-heading relative top-[8px]'>Approvals</h2>
            <div className='flex items-center gap-[15px] mt-[-55px]'>

                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Client:</label>
                    <Select
                        style={{ width: 150 }}
                        options={clients}
                        value={selectedclients}
                        onChange={handleChange}
                    />
                </div>
                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Project:</label>
                    <Select
                        style={{ width: 250 }}
                        value={selectedProjects}
                        onChange={handleChangeproject}
                        options={Projects}
                    />
                </div>
                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Employee:</label>
                    <Select
                        style={{ width: 200 }}
                        value={selectedemployee}
                        onChange={(e) => setselectedemployee(e)}
                        options={employee}
                    />
                </div>

                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Time Periods:</label>
                    <Select
                        style={{ width: 170 }}
                        placeholder="Time Period"
                        value={selectedTimePeriod}
                        options={options}
                        onChange={handleTimePeriodChange}
                    />
                </div>
                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Dates:</label>

                    {selectedTimePeriod === 'day' && (
                        <RangePicker
                            style={{ width: 260 }}
                            allowClear
                            defaultValue={[dayjs().startOf('day'), dayjs().endOf('day')]}
                            placeholder={['Start Date', 'End Date']}
                            format="DD-MM-YYYY"
                            onChange={handleDateChange}
                        />
                    )}
                    {selectedTimePeriod === 'month' && (
                        <RangePicker
                            style={{ width: 230 }}
                            allowClear={false}
                            defaultValue={[dayjs().startOf('month'), dayjs().endOf('month')]}
                            picker="month"
                            placeholder={['Start Month', 'End Month']}
                            format="MMM YYYY"
                            onChange={handleDateChange}
                            disabled={loading}
                            disabledDate={(current) => current && current > dayjs().endOf('month')}
                        />
                    )}
                    {selectedTimePeriod === 'week' && (
                        <Flatpickr
                            className={`ant-select ant-select-outlined w-[235px] ${loading ? 'date-picker-client-report-disabled' : 'date-picker-client-report'}`}
                            value={selectedWeekDates}
                            options={{
                                mode: "range",
                                dateFormat: "D, M j",
                                onChange: (dates, _str, instance) => { handleWeekSelection(dates, instance); },
                                disable: [
                                    function (date) {
                                        const weekStart = new Date(today);
                                        const dow = weekStart.getDay();
                                        weekStart.setDate(weekStart.getDate() - (dow === 0 ? 6 : dow - 1));
                                        const weekEnd = new Date(weekStart);
                                        weekEnd.setDate(weekStart.getDate() + 6);
                                        return date > weekEnd;   // no future weeks
                                    }
                                ],
                            }}
                            placeholder="Select Week"
                        />
                    )}
                </div>

            </div>

            {loading ? (
                <Spin size="small" className="justify-center items-center flex" style={{ height: '100vh' }}>
                    {table}
                </Spin>
            ) : table}
        </div>
    );
};